import RequesterConfig from '../RequesterConfig'

/**
 * The configuration object passed to a loader
 */
export default class LoaderConfig extends RequesterConfig {}
